module.exports = __webpack_public_path__ + "img/logo.1d2e4037.png";